import { render, staticRenderFns } from "./ForchangeTextarea.vue?vue&type=template&id=4c2c08a6&scoped=true&"
import script from "./ForchangeTextarea.vue?vue&type=script&lang=js&"
export * from "./ForchangeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ForchangeTextarea.vue?vue&type=style&index=0&id=4c2c08a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c08a6",
  null
  
)

export default component.exports